import { Component } from 'react';

class StellaLoading extends Component {
  render() {
    if (!this.props.loading) {
      return null;
    }
    let styles = {
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      float: 'left',
      textAlign: 'center',
      backgroundColor: 'rgba(250,250,250,0.7)',
      position: 'absolute',
      zIndex: this.props.zIndex || 100,
    };

    let imageStyle = {
      marginTop: '300px',
    };
    return (
      <div style={styles}>
        {this.props.loadingImage && (
          <img style={imageStyle} src={this.props.loadingImage} />
        )}
      </div>
    );
  }
}

export default StellaLoading;
